var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},_vm._l((_vm.stepsBooleans),function(step,index){return _c('div',{key:index,staticClass:"step",on:{"click":function($event){return _vm.handleClick(step,index)}}},[_c('div',{staticClass:"container",class:{ selected: step.isSelected,'current':index===_vm.selected }})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }